<template>
  <div>

		<SQLReport style="width:300px;" v-model="selectedReport" :listFormatters="listFormatters" >
    <!-- :listTitles="listTitles"> -->
		</SQLReport>
  </div>
</template>

<script>
import SQLReport from '../SQLReports/components/SQLReport.vue'

export default {
	name:'DailyTripSummary',
	components: {SQLReport},
  data () {return {
    selectedReport: {
      name: 'Daily Trip Summary',
      location: 'heroku',
      sql: `
select 
	date_trunc('day', effective_ts at time zone 'America/Regina') as day,
	SUM(CASE WHEN data->'account'->>'src' = '1' then 1 else 0 end)::text as total,
	SUM(CASE WHEN data->'account'->>'src' != '1' then 1 else 0 end)::text as street,
	SUM(CASE WHEN data->'account'->>'creator' = '13630' and data->'extra'->>'info' !~* 'test .*'
	then 1 else 0 END)::text as web,
	to_char(100.0 * (
		SUM(CASE WHEN data->'account'->>'creator' = '13630' and data->'extra'->>'info' !~* 'test .*' then 1 else 0 END)::float 
		/ ( 
			  SUM(CASE WHEN data->'account'->>'src' = '1' then 1 else 0 end)::float
		) 
	), '990.0') || ' %' as "web_%"
from taxicaller.job 

where date_trunc('day', effective_ts at time zone 'America/Regina') > date_trunc('day', now()) - '14 days'::interval
 and effective_ts < now()
group by date_trunc('day', effective_ts at time zone 'America/Regina')
order by date_trunc('day', effective_ts at time zone 'America/Regina') desc
      `
    },
    listFormatters: {
      'day': ['d', 'YYYY MMM ddd DD'],
      // 'settlement_date': ['d', 'YYYY-MM-DD'],
      // 'batch_number': ['n', '0'],
      // 'settled_amount': ['n', '0,0.00'],
      // 'amount': ['n', '0,0.00'],
    },
    // listTitles: {
    //   'group' : 'Location',
    //   'device_number' : 'Terminal ID',
    //   'vid' : 'Vehicle',
    // },

  }},
  created () {
    // this.loadData()
  },
  methods:{
  }
  
}
</script>

<style>

</style>
